import React from 'react';
import { arrayOf, func, string, shape } from 'prop-types';
import { CardMedia, Link, Typography } from '@one-thd/sui-atomic-components';

export const Thumbnails = ({ url, thumbnails }) => {

  const isEmptyProject = thumbnails?.length === 0;

  const EmptyProject = () => {
    return (
      [1, 2, 3].map((number, index) => {
        return (
          <div
            // eslint-disable-next-line tailwindcss/no-arbitrary-value
            className="sui-w-full"
            key={`project-tile-empty-thumbnail-${number}`}
          >
            <div className="sui-w-full sui-bg-strong sui-aspect-square" />
          </div>
        );
      })
    );
  };

  return (
    <Link
      className="sui-w-full sui-h-full"
      href={url}
      data-testid="image-project-link"
    >
      <div className="sui-grid sui-grid-cols-3 sui-gap-2">
        {!isEmptyProject ? (
          [1, 2, 3].map((thumbnailNumber, thumbnailIndex) => {
            const thumbnailUrl = thumbnails?.length >= thumbnailIndex && thumbnails?.[thumbnailIndex];
            return (
              <div key={`project-tile-thumbnail-${thumbnailNumber}`}>
                {thumbnailUrl ? (
                  <CardMedia className="sui-w-full sui-aspect-square" src={thumbnailUrl} alt="Product Image" />
                ) : (
                  <div className="sui-w-full sui-bg-strong sui-aspect-square" />
                )}
              </div>
            );
          })
        ) : (
          <EmptyProject />
        )}
      </div>
    </Link>
  );
};

Thumbnails.displayName = 'ProjectTileThumbnails';

Thumbnails.propTypes = {
  url: string.isRequired,
  thumbnails: arrayOf(string),
};

Thumbnails.defaultProps = {
  thumbnails: []
};